var openClass = 'open';


function initDocLib(componentId) {

    var $thisDocLib = $('section.doc_' + componentId);

    // Only apply to this doc lib

    $thisDocLib.find('.doc-list__title a').click(function (e) {
        e.preventDefault();
        console.log('doc list title clicked');
        var targetId = $(this).attr("href").replace("#", "");
        $('#' + targetId).toggleClass(openClass);
    });
}